/* tslint:disable */
/* eslint-disable */
/**
 * Rapurc API-spec
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Other structure to be demolished
 * @export
 * @interface OtherStructure
 */
export interface OtherStructure {
    /**
     * Structure name
     * @type {string}
     * @memberof OtherStructure
     */
    name: string;
    /**
     * More detailed description
     * @type {string}
     * @memberof OtherStructure
     */
    description: string;
}

export function OtherStructureFromJSON(json: any): OtherStructure {
    return OtherStructureFromJSONTyped(json, false);
}

export function OtherStructureFromJSONTyped(json: any, ignoreDiscriminator: boolean): OtherStructure {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'],
    };
}

export function OtherStructureToJSON(value?: OtherStructure | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'description': value.description,
    };
}


